module.exports = __webpack_public_path__ + "static/media/tesco.1fb9cd81.svg";